import { useEffect, useState } from 'react';

import { getCredits } from '../services/api.js';

const INITIAL = {
  loading: true,
  error: null,
  included: 0,
  purchased: 0,
  used: 0,
  remaining: 0,
  total: 0,
};

/**
 * Poll the org's enrichment credit balance for the sidebar counter.
 *
 * Refreshes every 60 seconds in the background. The sidebar reads `used`,
 * `total`, and `remaining` to render the progress bar and pick colour.
 */
export function useCredits({ pollMs = 60_000 } = {}) {
  const [state, setState] = useState(INITIAL);

  useEffect(() => {
    let cancelled = false;

    const fetchOnce = async () => {
      try {
        const data = await getCredits();
        if (cancelled) return;
        setState({
          loading: false,
          error: null,
          included: data.included ?? 0,
          purchased: data.purchased ?? 0,
          used: data.used ?? 0,
          remaining:
            data.remaining ??
            Math.max(0, (data.included || 0) + (data.purchased || 0) - (data.used || 0)),
          total: data.total ?? (data.included || 0) + (data.purchased || 0),
        });
      } catch (err) {
        if (cancelled) return;
        setState((prev) => ({ ...prev, loading: false, error: err }));
      }
    };

    fetchOnce();
    const timer = pollMs ? window.setInterval(fetchOnce, pollMs) : null;
    return () => {
      cancelled = true;
      if (timer) window.clearInterval(timer);
    };
  }, [pollMs]);

  return state;
}
